import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Button,
  Chip,
  Paper,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Breadcrumbs,
  Link as MuiLink,
  Snackbar,
  Alert,
  IconButton,
  Avatar,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Fade,
  Skeleton
} from '@mui/material';
import {
  Work as WorkIcon,
  LocationOn as LocationIcon,
  AccessTime as TimeIcon,
  NavigateNext as NavigateNextIcon,
  Close as CloseIcon,
  CloudUpload as CloudUploadIcon,
  Schedule as ScheduleIcon,
  Business as BusinessIcon,
  AttachMoney as AttachMoneyIcon,
  CalendarToday as CalendarTodayIcon,
  CheckCircle as CheckCircleIcon,
  Star as StarIcon,
  Share as ShareIcon,
  Bookmark as BookmarkIcon,
  ArrowBack as ArrowBackIcon
} from '@mui/icons-material';
import { Link, useParams, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const JobDetail = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [bookmarked, setBookmarked] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    experience: '',
    education: '',
    coverLetter: '',
    resume: null
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  // Mock job data - in real app, this would come from API
  const jobsData = {
    1: {
      id: 1,
      title: 'সিনিয়র সফটওয়্যার ইঞ্জিনিয়ার',
      department: 'আইটি',
      location: 'ঢাকা',
      type: 'ফুল-টাইম',
      experience: '৫+ বছর',
      salary: '৮০,০০০ - ১,২০,০০০ টাকা',
      deadline: '৩০ এপ্রিল, ২০২৪',
      posted: '৫ দিন আগে',
      featured: true,
      description: 'আমাদের টেক টিমে যোগ দিন এবং বাংলাদেশের সবচেয়ে বড় ই-কমার্স প্ল্যাটফর্মের উন্নয়নে অবদান রাখুন। আপনি আমাদের স্কেলেবল সিস্টেম ডিজাইন এবং উন্নত প্রযুক্তি নিয়ে কাজ করার সুযোগ পাবেন।',
      responsibilities: [
        'ওয়েব অ্যাপ্লিকেশন ডিজাইন এবং ডেভেলপমেন্ট',
        'কোড রিভিউ এবং টিম মেন্টরিং',
        'সিস্টেম আর্কিটেকচার ডিজাইন',
        'পারফরমেন্স অপটিমাইজেশন',
        'নতুন প্রযুক্তি রিসার্চ এবং ইমপ্লিমেন্টেশন'
      ],
      requirements: [
        'কমপক্ষে ৫ বছরের ওয়েব ডেভেলপমেন্ট অভিজ্ঞতা',
        'React, Node.js এ দক্ষতা',
        'AWS/GCP ক্লাউড সার্ভিসে অভিজ্ঞতা',
        'টিম লিডারশিপের অভিজ্ঞতা',
        'ডেটাবেস ডিজাইন এবং অপটিমাইজেশন',
        'RESTful API ডিজাইন এবং ডেভেলপমেন্ট'
      ],
      benefits: [
        'প্রতিযোগিতামূলক বেতন',
        'স্বাস্থ্য বীমা (পরিবারসহ)',
        'বার্ষিক বোনাস',
        'ফ্লেক্সিবল ওয়ার্কিং আওয়ার',
        'রিমোট ওয়ার্ক সুবিধা',
        'প্রশিক্ষণ এবং কনফারেন্স ভাতা',
        'ক্যারিয়ার ডেভেলপমেন্ট সাপোর্ট'
      ],
      companyInfo: {
        name: 'গ্রামীণ বাজার',
        size: '৫০০+ কর্মচারী',
        industry: 'ই-কমার্স',
        founded: '২০১৮'
      }
    },
    2: {
      id: 2,
      title: 'মার্কেটিং ম্যানেজার',
      department: 'মার্কেটিং',
      location: 'ঢাকা',
      type: 'ফুল-টাইম',
      experience: '৩+ বছর',
      salary: '৫০,০০০ - ৮০,০০০ টাকা',
      deadline: '২৫ এপ্রিল, ২০২৪',
      posted: '৩ দিন আগে',
      featured: false,
      description: 'ডিজিটাল মার্কেটিং স্ট্র্যাটেজি তৈরি ও বাস্তবায়নের জন্য অভিজ্ঞ মার্কেটিং ম্যানেজার প্রয়োজন।',
      responsibilities: [
        'মার্কেটিং ক্যাম্পেইন পরিকল্পনা ও বাস্তবায়ন',
        'সোশ্যাল মিডিয়া স্ট্র্যাটেজি',
        'ব্র্যান্ড ম্যানেজমেন্ট',
        'মার্কেট রিসার্চ এবং অ্যানালাইসিস'
      ],
      requirements: [
        'ডিজিটাল মার্কেটিংয়ে ৩+ বছরের অভিজ্ঞতা',
        'সোশ্যাল মিডিয়া ক্যাম্পেইন পরিচালনার অভিজ্ঞতা',
        'টিম ম্যানেজমেন্ট স্কিল',
        'বাজেট পরিচালনার অভিজ্ঞতা'
      ],
      benefits: [
        'প্রতিযোগিতামূলক বেতন',
        'স্বাস্থ্য বীমা',
        'প্রশিক্ষণের সুযোগ'
      ],
      companyInfo: {
        name: 'গ্রামীণ বাজার',
        size: '৫০০+ কর্মচারী',
        industry: 'ই-কমার্স',
        founded: '২০১৮'
      }
    },
    3: {
      id: 3,
      title: 'কাস্টমার সার্ভিস এক্সিকিউটিভ',
      department: 'কাস্টমার সার্ভিস',
      location: 'ঢাকা',
      type: 'ফুল-টাইম',
      experience: '১+ বছর',
      salary: '২৫,০০০ - ৪০,০০০ টাকা',
      deadline: '২০ এপ্রিল, ২০২৪',
      posted: '১ দিন আগে',
      featured: false,
      description: 'গ্রাহক সেবা প্রদানের জন্য উৎসাহী ও অভিজ্ঞ প্রার্থী প্রয়োজন।',
      responsibilities: [
        'গ্রাহক সেবা প্রদান',
        'অভিযোগ সমাধান',
        'অর্ডার ট্র্যাকিং সহায়তা',
        'গ্রাহক সন্তুষ্টি নিশ্চিতকরণ'
      ],
      requirements: [
        'কাস্টমার সার্ভিসে ১+ বছরের অভিজ্ঞতা',
        'উন্নত যোগাযোগ দক্ষতা',
        'ইংরেজি ও বাংলায় দক্ষতা',
        'কম্পিউটার দক্ষতা'
      ],
      benefits: [
        'প্রতিযোগিতামূলক বেতন',
        'স্বাস্থ্য বীমা',
        'ক্যারিয়ার গ্রোথের সুযোগ'
      ],
      companyInfo: {
        name: 'গ্রামীণ বাজার',
        size: '৫০০+ কর্মচারী',
        industry: 'ই-কমার্স',
        founded: '২০১৮'
      }
    }
  };

  useEffect(() => {
    // Simulate API call
    setTimeout(() => {
      const jobData = jobsData[jobId];
      if (jobData) {
        setJob(jobData);
      }
      setLoading(false);
    }, 1000);
  }, [jobId]);

  const handleApplyClick = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setFormData({
      name: '',
      email: '',
      phone: '',
      experience: '',
      education: '',
      coverLetter: '',
      resume: null
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({
        ...prev,
        resume: file
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Application submitted:', { ...formData, jobId: job.id });
    
    setSnackbar({
      open: true,
      message: 'আপনার আবেদন সফলভাবে জমা হয়েছে। আমরা শীঘ্রই যোগাযোগ করব।',
      severity: 'success'
    });

    handleCloseDialog();
  };

  const handleBookmark = () => {
    setBookmarked(!bookmarked);
    setSnackbar({
      open: true,
      message: bookmarked ? 'বুকমার্ক থেকে সরানো হয়েছে' : 'বুকমার্ক করা হয়েছে',
      severity: 'info'
    });
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: job?.title,
        text: job?.description,
        url: window.location.href,
      });
    } else {
      navigator.clipboard.writeText(window.location.href);
      setSnackbar({
        open: true,
        message: 'লিংক কপি করা হয়েছে',
        severity: 'info'
      });
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  if (loading) {
    return (
      <>
        <Header />
        <Container sx={{ py: 4 }}>
          <Skeleton variant="text" width="60%" height={40} />
          <Skeleton variant="rectangular" width="100%" height={400} sx={{ mt: 2 }} />
        </Container>
        <Footer />
      </>
    );
  }

  if (!job) {
    return (
      <>
        <Header />
        <Container sx={{ py: 8, textAlign: 'center' }}>
          <Typography variant="h4" gutterBottom>
            চাকরির পোস্ট পাওয়া যায়নি
          </Typography>
          <Button
            variant="contained"
            component={Link}
            to="/career"
            startIcon={<ArrowBackIcon />}
          >
            ক্যারিয়ার পেজে ফিরে যান
          </Button>
        </Container>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <Box sx={{ bgcolor: '#f8fafc', minHeight: '100vh', py: 4 }}>
        <Container>
          {/* Breadcrumbs */}
          <Breadcrumbs 
            separator={<NavigateNextIcon fontSize="small" />} 
            aria-label="breadcrumb"
            sx={{ mb: 3 }}
          >
            <MuiLink component={Link} to="/" color="inherit">
              হোম
            </MuiLink>
            <MuiLink component={Link} to="/career" color="inherit">
              ক্যারিয়ার
            </MuiLink>
            <Typography color="text.primary">{job.title}</Typography>
          </Breadcrumbs>

          <Grid container spacing={4}>
            {/* Main Content */}
            <Grid item xs={12} md={8}>
              <Fade in timeout={800}>
                <Card sx={{ mb: 4 }}>
                  <CardContent sx={{ p: 4 }}>
                    {/* Job Header */}
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                      <Avatar
                        sx={{
                          bgcolor: 'primary.main',
                          mr: 3,
                          width: 64,
                          height: 64
                        }}
                      >
                        <WorkIcon sx={{ fontSize: 32 }} />
                      </Avatar>
                      <Box sx={{ flex: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                          <Typography variant="h4" sx={{ fontWeight: 600 }}>
                            {job.title}
                          </Typography>
                          {job.featured && (
                            <Chip
                              icon={<StarIcon />}
                              label="ফিচার্ড"
                              color="primary"
                              size="small"
                            />
                          )}
                        </Box>
                        <Typography variant="h6" color="primary.main" sx={{ fontWeight: 500 }}>
                          {job.companyInfo.name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {job.posted} পোস্ট করা হয়েছে
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <IconButton onClick={handleBookmark} color={bookmarked ? 'primary' : 'default'}>
                          <BookmarkIcon />
                        </IconButton>
                        <IconButton onClick={handleShare}>
                          <ShareIcon />
                        </IconButton>
                      </Box>
                    </Box>

                    {/* Job Info Chips */}
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 4 }}>
                      <Chip
                        icon={<BusinessIcon />}
                        label={job.department}
                        variant="outlined"
                      />
                      <Chip
                        icon={<LocationIcon />}
                        label={job.location}
                        variant="outlined"
                      />
                      <Chip
                        icon={<TimeIcon />}
                        label={job.type}
                        variant="outlined"
                      />
                      <Chip
                        icon={<ScheduleIcon />}
                        label={job.experience}
                        variant="outlined"
                      />
                      <Chip
                        icon={<AttachMoneyIcon />}
                        label={job.salary}
                        variant="outlined"
                        color="primary"
                      />
                    </Box>

                    {/* Job Description */}
                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mt: 4 }}>
                      চাকরির বিবরণ
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
                      {job.description}
                    </Typography>

                    <Divider sx={{ my: 4 }} />

                    {/* Responsibilities */}
                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                      দায়িত্বসমূহ
                    </Typography>
                    <List>
                      {job.responsibilities.map((responsibility, index) => (
                        <ListItem key={index} sx={{ py: 0.5 }}>
                          <ListItemIcon>
                            <CheckCircleIcon color="primary" />
                          </ListItemIcon>
                          <ListItemText primary={responsibility} />
                        </ListItem>
                      ))}
                    </List>

                    <Divider sx={{ my: 4 }} />

                    {/* Requirements */}
                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                      প্রয়োজনীয় যোগ্যতা
                    </Typography>
                    <List>
                      {job.requirements.map((requirement, index) => (
                        <ListItem key={index} sx={{ py: 0.5 }}>
                          <ListItemIcon>
                            <CheckCircleIcon color="primary" />
                          </ListItemIcon>
                          <ListItemText primary={requirement} />
                        </ListItem>
                      ))}
                    </List>

                    <Divider sx={{ my: 4 }} />

                    {/* Benefits */}
                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                      সুবিধাসমূহ
                    </Typography>
                    <List>
                      {job.benefits.map((benefit, index) => (
                        <ListItem key={index} sx={{ py: 0.5 }}>
                          <ListItemIcon>
                            <CheckCircleIcon color="success.main" />
                          </ListItemIcon>
                          <ListItemText primary={benefit} />
                        </ListItem>
                      ))}
                    </List>
                  </CardContent>
                </Card>
              </Fade>
            </Grid>

            {/* Sidebar */}
            <Grid item xs={12} md={4}>
              <Fade in timeout={1000}>
                <Box sx={{ position: 'sticky', top: 20 }}>
                  {/* Apply Card */}
                  <Card sx={{ mb: 3 }}>
                    <CardContent sx={{ p: 3 }}>
                      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                        আবেদন করুন
                      </Typography>
                      <Box sx={{ mb: 3 }}>
                        <Typography variant="body2" color="text.secondary" gutterBottom>
                          আবেদনের শেষ তারিখ
                        </Typography>
                        <Typography variant="h6" color="error.main" sx={{ fontWeight: 600 }}>
                          <CalendarTodayIcon sx={{ fontSize: 16, mr: 1 }} />
                          {job.deadline}
                        </Typography>
                      </Box>
                      <Button
                        variant="contained"
                        fullWidth
                        size="large"
                        onClick={handleApplyClick}
                        sx={{
                          py: 1.5,
                          fontWeight: 600,
                          textTransform: 'none',
                          mb: 2
                        }}
                      >
                        এখনই আবেদন করুন
                      </Button>
                      <Button
                        variant="outlined"
                        fullWidth
                        component={Link}
                        to="/career"
                        startIcon={<ArrowBackIcon />}
                        sx={{ textTransform: 'none' }}
                      >
                        অন্যান্য চাকরি দেখুন
                      </Button>
                    </CardContent>
                  </Card>

                  {/* Company Info Card */}
                  <Card>
                    <CardContent sx={{ p: 3 }}>
                      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                        কোম্পানি সম্পর্কে
                      </Typography>
                      <Box sx={{ mb: 2 }}>
                        <Typography variant="body2" color="text.secondary">
                          কোম্পানির নাম
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          {job.companyInfo.name}
                        </Typography>
                      </Box>
                      <Box sx={{ mb: 2 }}>
                        <Typography variant="body2" color="text.secondary">
                          কর্মচারী সংখ্যা
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          {job.companyInfo.size}
                        </Typography>
                      </Box>
                      <Box sx={{ mb: 2 }}>
                        <Typography variant="body2" color="text.secondary">
                          ইন্ডাস্ট্রি
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          {job.companyInfo.industry}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography variant="body2" color="text.secondary">
                          প্রতিষ্ঠিত
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          {job.companyInfo.founded}
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Box>
              </Fade>
            </Grid>
          </Grid>

          {/* Application Dialog */}
          <Dialog 
            open={openDialog} 
            onClose={handleCloseDialog}
            maxWidth="md"
            fullWidth
            PaperProps={{
              sx: { borderRadius: 2 }
            }}
          >
            <DialogTitle sx={{ pb: 1 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                  {job.title} - আবেদন ফর্ম
                </Typography>
                <IconButton onClick={handleCloseDialog}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </DialogTitle>
            <DialogContent dividers sx={{ p: 3 }}>
              <form onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="নাম"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="ইমেইল"
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="ফোন"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="শিক্ষাগত যোগ্যতা"
                      name="education"
                      multiline
                      rows={3}
                      value={formData.education}
                      onChange={handleChange}
                      required
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="কর্ম অভিজ্ঞতা"
                      name="experience"
                      multiline
                      rows={4}
                      value={formData.experience}
                      onChange={handleChange}
                      required
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="কভার লেটার"
                      name="coverLetter"
                      multiline
                      rows={4}
                      value={formData.coverLetter}
                      onChange={handleChange}
                      variant="outlined"
                      helperText="কেন আপনি এই পজিশনের জন্য উপযুক্ত তা বর্ণনা করুন"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      component="label"
                      variant="outlined"
                      startIcon={<CloudUploadIcon />}
                      sx={{ mt: 1, py: 1.5, px: 3 }}
                    >
                      রিজুমে আপলোড করুন (PDF, DOC, DOCX)
                      <input
                        type="file"
                        hidden
                        accept=".pdf,.doc,.docx"
                        onChange={handleFileChange}
                      />
                    </Button>
                    {formData.resume && (
                      <Typography variant="body2" sx={{ mt: 1, color: 'success.main' }}>
                        ✓ {formData.resume.name}
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </form>
            </DialogContent>
            <DialogActions sx={{ p: 3 }}>
              <Button onClick={handleCloseDialog} size="large">
                বাতিল
              </Button>
              <Button 
                variant="contained" 
                onClick={handleSubmit}
                disabled={!formData.resume}
                size="large"
                sx={{ px: 4 }}
              >
                আবেদন জমা দিন
              </Button>
            </DialogActions>
          </Dialog>

          {/* Snackbar */}
          <Snackbar
            open={snackbar.open}
            autoHideDuration={6000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          >
            <Alert
              onClose={handleCloseSnackbar}
              severity={snackbar.severity}
              sx={{ width: '100%' }}
            >
              {snackbar.message}
            </Alert>
          </Snackbar>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default JobDetail; 